import { css } from '@emotion/react';

import { Spacing } from 'chatie-design-system';

import { media } from '@styles/css';

import Frame from './Frame';

const SKELETON_SECTION_COUNT = 3;
const SKELETON_CARD_COUNT = 4;

const sectionCSS = css`
  padding-top: ${Spacing.medium}px;
`;

const headerCSS = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${Spacing.medium}px ${Spacing.small}px;

  ${media.tablet} {
    padding: 0 ${Spacing.xlarge}px ${Spacing.small}px;
  }

  ${media.desktop} {
    padding: 0 ${Spacing.xxlarge}px ${Spacing.small}px;
  }

  .title {
    width: 112px;
    height: 16px;
  }

  .more {
    width: 40px;
    height: 14px;
  }
`;

const cardListCSS = css`
  display: flex;
  gap: ${Spacing.small}px;
  overflow: hidden;
  padding: ${Spacing.xsmall}px ${Spacing.medium}px ${Spacing.medium}px;

  ${media.tablet} {
    padding-right: ${Spacing.xlarge}px;
    padding-left: ${Spacing.xlarge}px;
  }

  ${media.desktop} {
    padding-right: ${Spacing.xxlarge}px;
    padding-left: ${Spacing.xxlarge}px;
  }
`;

const cardCSS = css`
  width: 120px;
  flex: 0 0 120px;

  .cover {
    width: 120px;
    height: 90px;
  }

  .story-title {
    width: 96px;
    height: 14px;
    margin-top: ${Spacing.xsmall}px;
  }

  .author {
    width: 64px;
    height: 12px;
    margin-top: ${Spacing.xxsmall}px;
  }
`;

const HomeSectionSkeleton = () => {
  return (
    <div role="status" aria-label="홈 추천 섹션을 불러오는 중">
      {Array.from({ length: SKELETON_SECTION_COUNT }, (_, sectionIndex) => (
        <section css={sectionCSS} key={`home-section-${sectionIndex}`}>
          <div css={headerCSS}>
            <Frame className="title" />
            <Frame className="more" />
          </div>
          <div css={cardListCSS}>
            {Array.from({ length: SKELETON_CARD_COUNT }, (_, cardIndex) => (
              <div
                css={cardCSS}
                key={`home-section-${sectionIndex}-card-${cardIndex}`}
              >
                <Frame className="cover" />
                <Frame className="story-title" />
                <Frame className="author" />
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default HomeSectionSkeleton;
